// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/LldDistrict.yaml
// Generated: 2026-10-20T14:02:11.544Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateLldDistrict, UpdateLldDistrict, LldDistrict } from '@/types/core/LldDistrict';

/**
 * LldDistrict Service
 * CRUD operations for LldDistrict via the ABP API.
 */
export const lldDistrictService = new EntityService<LldDistrict, CreateLldDistrict, UpdateLldDistrict>(
  '/api/core/llddistrict',
  'LldDistrict',
);
